/** 自列表顶部下拉关闭 sheet：超过 slop 判定前不在 touchmove 上调用 preventDefault */
export const SHEET_PULL_DOWN_SLOP_PX = 12;

export type SheetPullDownGestureDecision =
  | "commit"
  | "abort-pending"
  | "keep-pending";

export function sheetPullDownGestureDecision(args: {
  scrollTop: number;
  dy: number;
  slopPx?: number;
}): SheetPullDownGestureDecision {
  const slop = args.slopPx ?? SHEET_PULL_DOWN_SLOP_PX;
  if (args.scrollTop > 0) {
    return "abort-pending";
  }
  if (args.dy > slop) {
    return "commit";
  }
  if (args.dy < -slop) {
    return "abort-pending";
  }
  return "keep-pending";
}
